import { render, staticRenderFns } from "./BarChartReview.vue?vue&type=template&id=973f8b30&scoped=true&"
import script from "./BarChartReview.vue?vue&type=script&lang=js&"
export * from "./BarChartReview.vue?vue&type=script&lang=js&"
import style0 from "./BarChartReview.vue?vue&type=style&index=0&id=973f8b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973f8b30",
  null
  
)

export default component.exports